// Dependencies
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import UniversalRouter from 'universal-router';
import {StyleRoot} from 'radium';
import history from './lib/history';
import routes from './routes.jsx';
import store from './redux/clientStore';
import Theme from './components/theme/Theme.jsx';
import {setMerchant, setThemeName} from './redux/merchantReducer';
import Spinner from './components/spinner/Spinner.jsx';
import gtmService from "./lib/gtm-service";

import {LEO_MERCHANT_ID, LEO_THEME, LEO_THEME_NAME} from './dev.js'
import {resetCheckoutIfNeeded} from "./redux/checkoutProcessReducer";
import {GTMProvider} from '@elgorditosalsero/react-gtm-hook'

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(fab, far, fas);

store.dispatch(setMerchant(LEO_MERCHANT_ID));
store.dispatch(setThemeName(LEO_THEME_NAME));

const options ={
	baseUrl: '',
}
const router = new UniversalRouter(routes, options);

let container
let root;

function initRoot() {
	if(!container) {
		container = document.getElementById('root');
	}
	root = createRoot(container);
}

function setHtmlTitle(title) {
	const titleTag = document.getElementsByTagName('title')[0];
	titleTag.innerHTML = title;
}

function setFavIcon(){
	const favIconTag = document.getElementById('favicon');
	if(window?.LEO_THEME?.root?.favicon){
		favIconTag.href = window.LEO_THEME.root.favicon;
	}
}

function saleRedirect(route) {
	const event = store.getState().event.elements[route.saleRedirectEventUuid];
	if (event) {
		const salePrefix = event.seatingplanUuid ? 'sp/' : 'fs/';
		const url = salePrefix + event.uuid;
		history.replace(url);
	} else {
		history.push('event-error');
	}
}

function renderPage(route, merchantId, theme) {
	window.leo_renderSpinner = false;
	const gtmParams = gtmService.getGtmParams(theme);
	if (!root) {
		initRoot()
	}
	const code = <StyleRoot>
					<Provider store={store}>
						<Theme merchantId={merchantId} theme={theme}>
							{route.component}
						</Theme>
					</Provider>
				</StyleRoot>
	const codeToRender = gtmParams ?
		<GTMProvider state={gtmParams}>
			{code}
		</GTMProvider> : code

	root.render(
		codeToRender
	);
}

async function handleRouting(route) {
	const theme = LEO_THEME;
	const merchantId = LEO_MERCHANT_ID;
	let promiseListFetchData = route.fetchData.map(func => store.dispatch(func()));
	if (route.clientOnly) {
		const promiseListClient = route.clientOnly.map(func => store.dispatch(func()));
		promiseListFetchData = [...promiseListFetchData, ...promiseListClient];
	}
	const pageTitle = route.pageTitle ? 'leoticket - ' + route.pageTitle : 'leoticket';
	setHtmlTitle(pageTitle);
	setFavIcon();

	window.leo_renderSpinner = true;
	window.setTimeout(() => {
		if (window.leo_renderSpinner) {
			if (!root) {
				initRoot()
			}
			root.render(
				<StyleRoot>
					<Provider store={store}>
						<Theme merchantId={merchantId} theme={theme}>
							<Spinner/>
						</Theme>
					</Provider>
				</StyleRoot>
			);
		}
	}, 100);

	await Promise.all(promiseListFetchData);

	// reset Checkout process if route isn't checkout
	if (!route.checkoutProcess) {
		store.dispatch(resetCheckoutIfNeeded())
	}

	//const shoppingcart = store.getState().shoppingCart.elements[merchantId];
	//const bookingOffice = store.getState().bookingOffice;
	/* PaymentPage - we redirect to shopping cart page if there is no shopping cart, shopping cart is empty or PAYPAL_PLUS is expired/inactive */
	/*const redirectToShoppingcartPage = route.paymentPage ? shouldRedirectToShoppingcart(shoppingcart, bookingOffice) : false;
	if (redirectToShoppingcartPage) {
		history.push('/shoppingcart');
		return;
	} */

	if (route.saleRedirectEventUuid) {
		saleRedirect(route);
	} else {
		renderPage(route, merchantId, theme);
	}
}

async function render(location) {
	router.resolve(location.pathname).then(handleRouting).catch(err => {
		console.error(`Cant, resolve route: ${location.pathname}`, err);
		if ((err.domainObject === 'Event') && (err.statusCode === 'FORBIDDEN')) {
			history.push('event-error');
		}
	});
}

render(history.location) // initialize the app

history.listen(({ location }) => { // listen for client-side navigation
	render(location)
});

